module.exports = __webpack_public_path__ + "static/media/Form_Continue_Button@2x.4b1c0540.png";